<div class="fullscreen hide" [ngClass]="{ show: (show$ | async) }">
    <div class="row">
        <div class="col-12">
            <h2>
                {{ "NOTIFICATIONS.TITLE" | translate }}
                <button
                    [id]="'button_notification-popup_FecharNotificacoes'"
                    mat-icon-button
                    color="secondary"
                    aria-label="Fechar notificações"
                    (click)="close()"
                >
                    <mat-icon color="primary">clear</mat-icon>
                </button>
            </h2>
        </div>
    </div>
    <mat-tab-group headerPosition="below" mat-align-tabs="center" backgroundColor="primary">
        <mat-tab *ngFor="let not of notificacoes" [label]="'⦿'">
            <mat-card class="mat-elevation-z1">
                <mat-card-content>
                    <h3>
                        {{ not.title }}
                    </h3>
                    <p>{{ not.message }}</p>
                </mat-card-content>
            </mat-card>
            <mat-card class="mat-elevation-z1">
                <mat-card-content *ngIf="not.type == 'Video'">
                    <h3>
                        {{ not.title }}
                    </h3>
                    <div class="frame-container">
                        <app-video-player> </app-video-player>
                    </div>
                    <p>{{ not.message }}</p>
                </mat-card-content>
                <mat-card-content *ngIf="not.type == 'Imagem'">
                    <h3>
                        {{ not.title }}
                    </h3>
                    <div class="frame-container">
                        <img [src]="not.content" [alt]="not.title" />
                    </div>
                    <p>{{ not.message }}</p>
                </mat-card-content>
                <mat-card-content *ngIf="not.type == 'Texto'">
                    <div class="row">
                        <div class="col-12 frame-container" [innerHTML]="not.content"></div>
                    </div>
                </mat-card-content>
            </mat-card>
        </mat-tab>
    </mat-tab-group>
</div>
